export const NotificationsTranslationKeys = {
  teamAddMembersSuccess: 'team.add-member-modal.notifications.submit.success',
  teamAddMembersError: 'team.add-member-modal.notifications.submit.error',
  teamAddMembersUserAlreadyExistsError:
    'team.add-member-modal.notifications.submit.error.user-already-exists',
  teamMemberDeleteSuccess:
    'team.delete-modal.member.notifications.submit.success',
  teamMemberDeleteError: 'team.delete-modal.member.notifications.submit.error',
  teamInvitationDeleteSuccess:
    'team.delete-modal.invitation.notifications.submit.success',
  teamInvitationDeleteError:
    'team.delete-modal.invitation.notifications.submit.error',
  teamMemberEditSuccess: 'team.edit-member-modal.notifications.submit.success',
  teamMemberEditError: 'team.edit-member-modal.notifications.submit.error',
  projectOverviewMembersUpdateMembersSuccess:
    'project-overview.members.members-list-modal.notifications.update.success',
  projectOverviewMembersUpdateMembersError:
    'project-overview.members.members-list-modal.notifications.update.error',
  projectOverviewMembersUpdateMemberSuccess:
    'project-overview.members.members-edit-modal.notifications.update.success',
  projectOverviewMembersUpdateMemberError:
    'project-overview.members.members-edit-modal.notifications.update.error',
  projectOverviewMembersRemoveInvitationPermissionsSuccess:
    'project-overview.members.delete-modal.invitation.notifications.submit.success',
  projectOverviewMembersRemoveInvitationPermissionsError:
    'project-overview.members.delete-modal.invitation.notifications.submit.error',
  projectOverviewMembersRemoveMemberPermissionsSuccess:
    'project-overview.members.delete-modal.member.notifications.submit.success',
  projectOverviewMembersRemoveMemberPermissionsError:
    'project-overview.members.delete-modal.member.notifications.submit.error',
  projectOverviewMembersSendInvitationError:
    'project-overview.members.add-modal.member.notifications.send-invitation.submit.error',
  projectOverviewMembersAddInvitationToProjectError:
    'project-overview.members.add-modal.member.notifications.add-invitation-to-project.submit.error',
  projectOverviewMembersAddMemberToProjectError:
    'project-overview.members.add-modal.member.notifications.add-member-to-project.submit.error',
  projectOverviewMembersAddMembersToProjectSuccess:
    'project-overview.members.add-modal.member.notifications.submit.success',
  projectOverviewMembersAddMembersToProjectError:
    'project-overview.members.add-modal.member.notifications.submit.error',
  replicationsEnableReplicationStart:
    'replications.notifications.enable-replication.start',
  replicationsDisableReplicationStart:
    'replications.notifications.disable-replication.start',
  replicationsEnableReplicationSuccess:
    'replications.notifications.replication-enabled.success',
  replicationsDisableReplicationSuccess:
    'replications.notifications.replication-disabled.success',
  replicationsChangeReplicationActiveStatusError:
    'replications.notifications.change-replication-active-status.error',
  replicationsUpdateReplicationSuccess:
    'replications.notifications.update-replication.success',
  replicationsUpdateReplicationError:
    'replications.notifications.update-replication.error',
};
